
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface RecordingInProgressModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function RecordingInProgressModal({ isOpen, onClose }: RecordingInProgressModalProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px] w-full">
        <DialogHeader>
          <DialogTitle className="text-2xl title-green">{t("analysis_in_progress")}</DialogTitle>
        </DialogHeader>
        <DialogDescription>{t("analysis_in_progress_description")}</DialogDescription>
        <DialogFooter>
          <Button onClick={onClose}>
            {t("close")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default RecordingInProgressModal;
